import { Box, Text, Image } from '@chakra-ui/react';
import React from 'react';
interface Props {
	streaksDone: number;
	streakLimit: number;
}
const StreakList = ({ streaksDone, streakLimit }: Props) => {
	return (
		<Box justifyContent={'center'} display={'flex'} gap="20px" flexWrap={'wrap'}>
			{[...Array(streakLimit)].map((_, index) => {
				return (
					<Box key={index}>
						<Text textAlign={'center'} textStyle="body2-md" fontWeight={500} fontSize="12px">
							{index + 1}
						</Text>
						{index + 1 <= streaksDone ? <Image src="/images/streak-completed.svg" /> : <Image src="/images/streak-pending.svg" />}
					</Box>
				);
			})}
		</Box>
	);
};

export default StreakList;
